function Heading(props) {
    let title = "This is My first React application"
    console.log('Heading props:', props);
    return (
      <h1>{props.title}. {title}</h1>
    );
}

export default Heading;